class ReadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.content = this.querySelector('.read-more-content');
    this.readMoreText = this.button.dataset.readMore || 'Read More';
    this.readLessText = this.button.dataset.readLess || 'Read Less';
    
    this.button.addEventListener('click', this.toggleContent.bind(this));
    
    // Initialize the component
    this.init();
  }
  
  init() {
    // Set initial state
    this.content.classList.add('read-more-content--collapsed');
    this.button.textContent = this.readMoreText;
    this.button.setAttribute('aria-expanded', 'false');
  }
  
  toggleContent() {
    const isExpanded = this.content.classList.contains('read-more-content--expanded');
    
    if (isExpanded) {
      // Collapse
      this.content.classList.remove('read-more-content--expanded');
      this.content.classList.add('read-more-content--collapsed');
      this.button.textContent = this.readMoreText;
      this.button.setAttribute('aria-expanded', 'false');
    } else {
      // Expand
      this.content.classList.remove('read-more-content--collapsed');
      this.content.classList.add('read-more-content--expanded');
      this.button.textContent = this.readLessText;
      this.button.setAttribute('aria-expanded', 'true');
    }
  }
}

customElements.define('read-more-button', ReadMoreButton);
